"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearArea = exports.cut = exports.runFixer = exports.runPaintFloors = exports.update = exports.get = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var voyageShipSaver_sidecar_1 = require("@voyage/saver/voyageShipSaver-sidecar");
var voyageCamera_zoomer_sidecar_1 = require("@voyage/camera/voyageCamera_zoomer-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var diveKeyboard_sidecar_1 = require("@voyage/input/diveKeyboard-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageTileData_1 = require("./voyageTileData");
var voyageTileData_sidecar_1 = require("./voyageTileData-sidecar");
var voyageTilemap_sidecar_1 = require("./voyageTilemap-sidecar");
var voyageTilemapEditor_data_1 = require("./voyageTilemapEditor_data");
var voyageTilemapPart_sidecar_1 = require("./voyageTilemapPart-sidecar");
var _obj = null;
function get() {
    //assert.notNil(_obj, 'editor not created')
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
function create() {
    var imageCursor = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().shipAbove, sprites_sidecar_1.sprites.voyTileCursor[0]);
    var imageCut1 = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().shipAbove, sprites_sidecar_1.sprites.voyTileX[0]);
    var imageCut2 = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().shipAbove, sprites_sidecar_1.sprites.voyTileX[0]);
    var imageTile = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().shipAbove, sprites_sidecar_1.sprites.voyTileTri1[0]);
    var textTile = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font4, 0, 0, voyageLayers_sidecar_1.voyageLayers.getLayers().shipAbove);
    stevieTexts2_sidecar_1.stevieTexts2.setScale(textTile, 3);
    var obj = {
        imageCursor: imageCursor,
        textTile: textTile,
        imageTile: imageTile,
        imageCut1: imageCut1,
        imageCut2: imageCut2,
        curTileIdx: 0,
        curTileSubIdx: 0,
        colorIdx: 4,
        layerIdx: 1,
        cutMode: false,
        cutIdx: false,
        cutTile1: null,
        cutTile2: null,
        clearFlip: false,
        brushSize: 1,
        stampText: '',
        mode: 'hull',
    };
    var s = common_sidecar_1.common.getPhaserScene();
    s.input.on('wheel', function (_pointer, _gameObjects, deltaX, deltaY, _deltaZ) {
        if (voyageGameManager_sidecar_1.voyageGameManager.get().mode === 'editor') {
            // console.log('editor mouse wheel', deltaX, deltaY)
            var keys = diveKeyboard_sidecar_1.diveKeyboard.getKeys();
            if (keys.shift) {
                voyageCamera_zoomer_sidecar_1.voyageCamera_zoomer.onWheel(deltaY);
                return;
            }
            if (obj.mode !== 'old') {
                if (deltaY > 0) {
                    obj.curTileIdx++;
                }
                if (deltaY < 0) {
                    obj.curTileIdx--;
                }
            }
            else {
                if (keys.control) {
                    if (deltaY > 0) {
                        obj.colorIdx++; //= mathUtils.wrapIndex(obj.colorIdx + 1, voyageColors.all)
                    }
                    if (deltaY < 0) {
                        obj.colorIdx--; // = mathUtils.wrapIndex(obj.colorIdx - 1, voyageColors.all)
                    }
                }
                else {
                    var curTile = getCurrentTile();
                    obj.curTileSubIdx = mathUtils_sidecar_1.mathUtils.wrapIndex(obj.curTileSubIdx, curTile.frames);
                    if (deltaY > 0) {
                        obj.curTileSubIdx++;
                        if (obj.curTileSubIdx >= curTile.frames.length) {
                            obj.curTileIdx++;
                            obj.curTileSubIdx = 0;
                        }
                    }
                    if (deltaY < 0) {
                        obj.curTileSubIdx--;
                        if (obj.curTileSubIdx < 0) {
                            obj.curTileIdx--;
                            curTile = getCurrentTile();
                            obj.curTileSubIdx = curTile.frames.length - 1;
                        }
                    }
                }
            }
        }
    });
    return obj;
}
function getCurrentTile() {
    var obj = get();
    var curTile = voyageTileData_sidecar_1.voyageTileData.get(voyageTileData_1.EVoyageTile.Square);
    obj.stampText = '';
    if (obj.mode === 'old') {
        if (obj.layerIdx === 1) {
            curTile = mathUtils_sidecar_1.mathUtils.getIndexWrapped(obj.curTileIdx, voyageTileData_sidecar_1.voyageTileData.layer1);
        }
        if (obj.layerIdx === 2) {
            curTile = mathUtils_sidecar_1.mathUtils.getIndexWrapped(obj.curTileIdx, voyageTileData_sidecar_1.voyageTileData.layer2);
        }
        if (obj.layerIdx === 3) {
            curTile = mathUtils_sidecar_1.mathUtils.getIndexWrapped(obj.curTileIdx, voyageTileData_sidecar_1.voyageTileData.layer3);
        }
    }
    var data = [];
    if (obj.mode === 'hull') {
        data = voyageTilemapEditor_data_1.specialLayerData_hull;
    }
    if (obj.mode === 'sys') {
        data = voyageTilemapEditor_data_1.specialLayerData_sys;
    }
    if (obj.mode === 'floor') {
        data = voyageTilemapEditor_data_1.specialLayerData_floor;
    }
    if (obj.mode === 'decor') {
        data = voyageTilemapEditor_data_1.specialLayerData_decor;
    }
    if (data.length > 0) {
        var d = mathUtils_sidecar_1.mathUtils.getIndexWrapped(obj.curTileIdx, data);
        curTile = voyageTileData_sidecar_1.voyageTileData.get(d.t);
        obj.curTileSubIdx = d.s || 0;
        obj.colorIdx = d.c || 0;
        obj.stampText = d.text || '';
    }
    return curTile;
}
function update() {
    var obj = get();
    if (voyageGameManager_sidecar_1.voyageGameManager.get().mode !== 'editor') {
        obj.imageCursor.visible = false;
        obj.imageCut1.visible = false;
        obj.imageCut2.visible = false;
        obj.imageTile.visible = false;
        stevieTexts2_sidecar_1.stevieTexts2.setVisible(obj.textTile, false);
        return;
    }
    stevieTexts2_sidecar_1.stevieTexts2.setVisible(obj.textTile, true);
    stevieTexts2_sidecar_1.stevieTexts2.setText(obj.textTile, obj.stampText);
    stevieTexts2_sidecar_1.stevieTexts2.moveTo(obj.textTile, obj.imageTile.x, obj.imageTile.y);
    obj.imageCut1.visible = obj.cutMode;
    obj.imageCut2.visible = obj.cutMode;
    //let mou = voyageCamera.getAdjustedMousePosition()
    var mij = voyageTilemap_sidecar_1.voyageTilemap.getIJAtMouse();
    var mxy = voyageTilemap_sidecar_1.voyageTilemap.convertIJtoXY(mij.i, mij.j);
    obj.imageCursor.x = mxy.x; //mou.max
    obj.imageCursor.y = mxy.y; //mou.may
    var curTile = getCurrentTile();
    obj.imageTile.visible = true;
    spritesUtil_sidecar_1.spritesUtil.setPackedFrame(obj.imageTile, mathUtils_sidecar_1.mathUtils.getIndexWrapped(obj.curTileSubIdx, curTile.frames));
    obj.imageTile.tint = mathUtils_sidecar_1.mathUtils.getIndexWrapped(obj.colorIdx, curTile.colors); // , voyageColors.all[obj.colorIdx]
    obj.imageTile.x = mxy.x; //mou.max
    obj.imageTile.y = mxy.y; //mou.may
    if (clickEater_sidecar_1.clickEater.isLeftDownAndUneaten()) {
        var t = voyageTilemap_sidecar_1.voyageTilemap.getSafe(mij.i, mij.j);
        if (t) {
            if (obj.cutMode) {
                if (clickEater_sidecar_1.clickEater.isLeftFirstDownAndUneaten()) {
                    if (obj.cutIdx === false) {
                        obj.cutTile1 = t;
                        obj.imageCut1.x = t.x;
                        obj.imageCut1.y = t.y;
                    }
                    else {
                        obj.cutTile2 = t;
                        obj.imageCut2.x = t.x;
                        obj.imageCut2.y = t.y;
                    }
                    obj.cutIdx = !obj.cutIdx;
                }
            }
            else {
                if (obj.brushSize === 1) {
                    voyageTilemapPart_sidecar_1.voyageTilemapPart.setTile(t, curTile, obj.curTileSubIdx, obj.colorIdx);
                    if (obj.stampText) {
                        t.text3 = obj.stampText;
                    }
                }
                else {
                    for (var oi = -1; oi <= 1; oi++) {
                        for (var oj = -1; oj <= 1; oj++) {
                            var t2 = voyageTilemap_sidecar_1.voyageTilemap.getSafe(mij.i + oi, mij.j + oj);
                            if (t2) {
                                if (t2.tile2.type === voyageTileData_1.EVoyageTile.Null2 ||
                                    (t2.tile2.type === voyageTileData_1.EVoyageTile.Square && t2.colorIdx2 !== 1)) {
                                    voyageTilemapPart_sidecar_1.voyageTilemapPart.setTile(t2, curTile, obj.curTileSubIdx, obj.colorIdx);
                                }
                            }
                        }
                    }
                }
                voyageShipSaver_sidecar_1.voyageShipSaver.setDirty();
                if (curTile.type === voyageTileData_1.EVoyageTile.Null3) {
                    voyageTilemapPart_sidecar_1.voyageTilemapPart.setText(t, '');
                }
                if (curTile.includesText && clickEater_sidecar_1.clickEater.isLeftFirstDownAndUneaten()) {
                    var r = prompt('Text', t.text3 || '');
                    if (r != null) {
                        voyageTilemapPart_sidecar_1.voyageTilemapPart.setText(t, r.toLowerCase());
                        voyageShipSaver_sidecar_1.voyageShipSaver.setDirty();
                    }
                    clickEater_sidecar_1.clickEater.reset();
                    clickEater_sidecar_1.clickEater.tempEat();
                }
            }
        }
    }
}
exports.update = update;
function runPaintFloors(color) {
    var tm = voyageTilemap_sidecar_1.voyageTilemap.get();
    var width = tm.width;
    var height = tm.height;
    for (var j = 0; j < height; j++) {
        for (var i = 0; i < width; i++) {
            var t = voyageTilemap_sidecar_1.voyageTilemap.getUnsafe(i, j);
            if (t.tile2.canWalk) {
                assert_sidecar_1.assert.notNil(t.image2);
                t.image2.tint = color;
            }
        }
    }
}
exports.runPaintFloors = runPaintFloors;
function runFixer() {
    // let tm = voyageTilemap.get()
    // let width = tm.width
    // let height = tm.height
    // let tileData = voyageTileData.get(EVoyageTile.SquareBottom)
    // for (let j = 0; j < height; j++) {
    //   for (let i = 0; i < width; i++) {
    //     let t = voyageTilemap.getUnsafe(i, j)
    //     if (t.tile1.type === EVoyageTile.CheckerBottom) {
    //       voyageTilemapPart.setTile(t, tileData, 0, 0)
    //     }
    //   }
    // }
    return; // disable, already ran
    // let tm = voyageTilemap.get()
    // let width = tm.width
    // let height = tm.height
    // for (let j = 0; j < height; j++) {
    //   for (let i = 0; i < width; i++) {
    //     let t = voyageTilemap.getUnsafe(i, j)
    //     if (t.tile2.type === EVoyageTile.Triangle) {
    //       if (t.subTileIdx2 === 2) {
    //         assert.notNil(t.image2)
    //         t.image2.tint = 0xff0000
    //         t.subTileIdx2 = 5
    //       }
    //       if (t.subTileIdx2 === 3) {
    //         assert.notNil(t.image2)
    //         t.image2.tint = 0x00ff00
    //         t.subTileIdx2 = 2
    //       }
    //       // assert.notNil(t.image2)
    //       // t.image2.tint = color
    //     }
    //   }
    // }
    // for (let j = 0; j < height; j++) {
    //   for (let i = 0; i < width; i++) {
    //     let t = voyageTilemap.getUnsafe(i, j)
    //     if (t.tile2.type === EVoyageTile.Triangle) {
    //       if (t.subTileIdx2 === 5) {
    //         t.subTileIdx2 = 3
    //       }
    //     }
    //   }
    // }
}
exports.runFixer = runFixer;
function cut(oi, oj) {
    var obj = get();
    if (!obj.cutTile1 || !obj.cutTile2) {
        return;
    }
    var minI = mathUtils_sidecar_1.mathUtils.min(obj.cutTile1.i, obj.cutTile2.i);
    var maxI = mathUtils_sidecar_1.mathUtils.max(obj.cutTile1.i, obj.cutTile2.i);
    var minJ = mathUtils_sidecar_1.mathUtils.min(obj.cutTile1.j, obj.cutTile2.j);
    var maxJ = mathUtils_sidecar_1.mathUtils.max(obj.cutTile1.j, obj.cutTile2.j);
    for (var idxJ = minJ; idxJ <= maxJ; idxJ++) {
        var j = idxJ;
        if (oj > 0) {
            j = maxJ - idxJ + minJ;
        }
        for (var idxI = minI; idxI <= maxI; idxI++) {
            var i = idxI;
            if (oi > 0) {
                i = maxI - idxI + minI;
            }
            var tSrc = voyageTilemap_sidecar_1.voyageTilemap.getSafe(i, j);
            var tDest = voyageTilemap_sidecar_1.voyageTilemap.getSafeOffset({ i: i, j: j }, oi, oj);
            if (tDest && tSrc) {
                console.log('try', tSrc.i, tDest.i, tSrc.j, tDest.j);
                voyageTilemapPart_sidecar_1.voyageTilemapPart.setText(tDest, tSrc.text3);
                voyageTilemapPart_sidecar_1.voyageTilemapPart.setTile(tDest, tSrc.tile1, tSrc.subTileIdx1, tSrc.colorIdx1);
                voyageTilemapPart_sidecar_1.voyageTilemapPart.setTile(tDest, tSrc.tile2, tSrc.subTileIdx2, tSrc.colorIdx2);
                voyageTilemapPart_sidecar_1.voyageTilemapPart.setTile(tDest, tSrc.tile3, tSrc.subTileIdx3, tSrc.colorIdx3);
            }
        }
    }
    if (oi === -1) {
        var i = maxI;
        for (var idxJ = minJ; idxJ <= maxJ; idxJ++) {
            erase(i, idxJ);
        }
    }
    if (oi === 1) {
        var i = minI;
        for (var idxJ = minJ; idxJ <= maxJ; idxJ++) {
            erase(i, idxJ);
        }
    }
    if (oj === -1) {
        var j = maxJ;
        for (var idxI = minI; idxI <= maxI; idxI++) {
            erase(idxI, j);
        }
    }
    if (oj === 1) {
        var j = minJ;
        for (var idxI = minI; idxI <= maxI; idxI++) {
            erase(idxI, j);
        }
    }
    var t1 = voyageTilemap_sidecar_1.voyageTilemap.getSafe(minI + oi, minJ + oj);
    if (t1) {
        obj.cutTile1 = t1;
        obj.imageCut1.x = t1.x;
        obj.imageCut1.y = t1.y;
    }
    var t2 = voyageTilemap_sidecar_1.voyageTilemap.getSafe(maxI + oi, maxJ + oj);
    if (t2) {
        obj.cutTile2 = t2;
        obj.imageCut2.x = t2.x;
        obj.imageCut2.y = t2.y;
    }
    voyageShipSaver_sidecar_1.voyageShipSaver.setDirty();
}
exports.cut = cut;
var erase = function (i, j, bottom) {
    if (bottom === void 0) { bottom = voyageTileData_1.EVoyageTile.SquareBottom; }
    var t1 = voyageTilemap_sidecar_1.voyageTilemap.getSafe(i, j);
    if (t1) {
        voyageTilemapPart_sidecar_1.voyageTilemapPart.setText(t1, '');
        voyageTilemapPart_sidecar_1.voyageTilemapPart.setTile(t1, voyageTileData_sidecar_1.voyageTileData.get(bottom), 0, 0);
        voyageTilemapPart_sidecar_1.voyageTilemapPart.setTile(t1, voyageTileData_sidecar_1.voyageTileData.get(voyageTileData_1.EVoyageTile.Null2), 0, 0);
        voyageTilemapPart_sidecar_1.voyageTilemapPart.setTile(t1, voyageTileData_sidecar_1.voyageTileData.get(voyageTileData_1.EVoyageTile.Null3), 0, 0);
    }
};
function clearArea() {
    var obj = get();
    if (!obj.cutTile1 || !obj.cutTile2) {
        return;
    }
    var minI = mathUtils_sidecar_1.mathUtils.min(obj.cutTile1.i, obj.cutTile2.i);
    var maxI = mathUtils_sidecar_1.mathUtils.max(obj.cutTile1.i, obj.cutTile2.i);
    var minJ = mathUtils_sidecar_1.mathUtils.min(obj.cutTile1.j, obj.cutTile2.j);
    var maxJ = mathUtils_sidecar_1.mathUtils.max(obj.cutTile1.j, obj.cutTile2.j);
    obj.clearFlip = !obj.clearFlip;
    for (var idxJ = minJ; idxJ <= maxJ; idxJ++) {
        var j = idxJ;
        for (var idxI = minI; idxI <= maxI; idxI++) {
            var i = idxI;
            erase(i, j, obj.clearFlip ? voyageTileData_1.EVoyageTile.SquareBottom : voyageTileData_1.EVoyageTile.CheckerBottom);
        }
    }
    voyageShipSaver_sidecar_1.voyageShipSaver.setDirty();
}
exports.clearArea = clearArea;
